// Keep the live feed below windows without lowering the dock, dice or refusal surface.
export function mountFt3dFeedLayer(root: HTMLElement): void {
    const feed = root.querySelector<HTMLElement>('[data-ft3d-feed]');
    const dockZone = feed?.parentElement;
    if (!feed || !dockZone) return; // Embedded HUDs have no feed.

    const layer = document.createElement('div');
    layer.className = 'ft3d-hud ft3d-hud__feed-layer';
    const zone = document.createElement('div');
    zone.className = dockZone.className;
    const clearance = document.createElement('div');
    clearance.className = 'ft3d-hud__feed-clearance';
    const log = feed.querySelector<HTMLElement>('[data-ft3d-log]');
    const scrollTop = log?.scrollTop ?? 0;
    zone.append(feed, clearance); // Move, never recreate: preserve rows, scroll and bound controls.
    layer.append(zone);
    // Campaign windows and the Training Grounds room each have their own stacking context.
    const view = document.querySelector<HTMLElement>('.ft3d-campaign-encounter-view');
    (view ?? document.body).append(layer);
    if (log) log.scrollTop = scrollTop; // Detaching a scroll container resets its offset.

    // The asynchronous practice room replaces the entry children. Wait for its Workspace before
    // joining that inner context; appending at HUD boot would let replaceChildren remove the feed.
    const room = document.getElementById('ft-training-grounds-root');
    if (room) {
        const joinRoom = (): boolean => {
            if (!room.querySelector('[data-ft3d-window="workspace"]')) return false;
            const scrollTop = log?.scrollTop ?? 0;
            room.append(layer);
            if (log) log.scrollTop = scrollTop;
            return true;
        };
        if (!joinRoom()) {
            const ready = new MutationObserver(() => { if (joinRoom()) ready.disconnect(); });
            ready.observe(room, { childList: true });
        }
    }

    // Reserve exactly the dice/dock stack still above us. Both zones keep their existing flex gap,
    // padding and right margin, including on phones and routes without campaign chrome.
    const align = (): void => {
        const height = dockZone.getBoundingClientRect().height;
        clearance.hidden = height === 0;
        clearance.style.height = `${height}px`;
    };
    new ResizeObserver(align).observe(dockZone);
    align();

    // Water-meter hover used to reach the feed through its HUD ancestor. Preserve that contract
    // after the move; the marker remains unique on the original high-priority HUD.
    const yieldToMeter = (): void => {
        layer.classList.toggle('ft3d-hud--yield', root.classList.contains('ft3d-hud--yield'));
    };
    new MutationObserver(yieldToMeter).observe(root, { attributes: true, attributeFilter: ['class'] });
    yieldToMeter();
}
